import { render, staticRenderFns } from "./AssetImagesList.vue?vue&type=template&id=ccfa1ce6&scoped=true&"
import script from "./AssetImagesList.vue?vue&type=script&lang=js&"
export * from "./AssetImagesList.vue?vue&type=script&lang=js&"
import style0 from "./AssetImagesList.vue?vue&type=style&index=0&id=ccfa1ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfa1ce6",
  null
  
)

export default component.exports